import { render, staticRenderFns } from "./AiDesigner.vue?vue&type=template&id=6272d9d0"
import script from "./AiDesigner.vue?vue&type=script&lang=js"
export * from "./AiDesigner.vue?vue&type=script&lang=js"
import style0 from "./AiDesigner.vue?vue&type=style&index=0&id=6272d9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports